import { registerPlugin } from '@capacitor/core';

const BPPlugin = registerPlugin('BPPlugin');

export default BPPlugin;